<template>
  <div
    class="game_pack_container d-flex-column justify-start align-start mobile-styles"
  >
    <div class="d-flex-row space-between">
      <h5 class="t-white title-h5 font-family-1 f-w-600" v-if="showTitle">
        {{ $t("main.boosting") }}
      </h5>
      <div class="d-flex-row justify-end md-hide">
        <button
          class="dark opacity regular-s f-w-600 height-40 border-none width-40 circular font-family-1"
          @click="swiperRef?.slidePrev()"
        >
          <chev-left />
        </button>
        <button
          class="dark opacity regular-s height-40 width-40 border-none circular f-w-600 font-family-1"
          @click="swiperRef?.slideNext()"
        >
          <chev-right />
        </button>
        <NuxtLinkLocale
          :to="`${currentGameSlug}`"
          class="medium dark orange b-radius-6 regular-s f-w-600 font-family-1"
        >
          {{ $t("main.view_all") }}
        </NuxtLinkLocale>
      </div>
    </div>
    <div
      class="game_pack_cards_container md-hide"
      ref="packs_container"
      v-if="!$isMobile()"
    >
      <ClientOnly>
        <swiper
          @swiper="onSwiper"
          :space-between="30"
          :slides-per-view="5"
          :centered-slides="false"
          :breakpoints="breakpoints"
        >
          <swiper-slide v-for="(gamePack, i) in packs" :key="gamePack.slug">
            <PackCard
              :id="gamePack.id"
              :title="gamePack.short_title"
              :full-title="gamePack.title"
              :slug="gamePack.slug"
              :image="gamePack.image"
              :index="i"
              :perks="gamePack?.perks || []"
              :link="`/${currentGameSlug}/${gamePack.slug}`"
              :current-game-slug="currentGameSlug"
              :is-new="gamePack?.is_new"
              :slider-chip="true"
            />
          </swiper-slide>
          <swiper-slide v-if="extraPack">
            <PackCard
              v-if="extraPack"
              :key="extraPack"
              :title="extraPack.short_title"
              :image="extraPack.image"
              :index="2"
              :perks="extraPack?.perks || []"
              :link="`/${currentGameSlug}/${extraPack.slug}`"
              :current-game-slug="currentGameSlug"
              :is-new="gamePack?.is_new"
              :slider-chip="true"
            />
          </swiper-slide>
        </swiper>
      </ClientOnly>
    </div>

    <div
      class="d-flex-column justify-start align-start above-md-hide"
      v-if="$isMobile()"
    >
      <PackCard
        v-for="(gamePack, i) in packs"
        :key="gamePack.slug"
        :id="gamePack.id"
        :title="gamePack.short_title"
        :full-title="gamePack.title"
        :slug="gamePack.slug"
        :image="gamePack.image"
        :index="i"
        :perks="gamePack?.perks || []"
        :link="`/${currentGameSlug}/${gamePack.slug}`"
        :current-game-slug="currentGameSlug"
        :is-new="gamePack?.is_new"
        :slider-chip="false"
      />
      <PackCard
        v-if="extraPack"
        :key="extraPack"
        :title="extraPack.short_title"
        :image="extraPack.image"
        :index="2"
        :perks="extraPack?.perks || []"
        :link="`/${currentGameSlug}/${extraPack?.slug}`"
        :current-game-slug="currentGameSlug"
        :is-new="gamePack?.is_new"
        :slider-chip="false"
      />

      <div
        class="game_pack_card t-white d-flex-column space-between align-start"
        style="visibility: hidden"
        v-if="gameStore.getGameLoading"
      ></div>
    </div>
    <div
      class="d-flex-column justify-start align-start above-md-hide"
      v-if="!$isMobile()"
    >
      <PackCard
        v-for="(gamePack, i) in packs"
        :key="gamePack.slug"
        :id="gamePack.id"
        :title="gamePack.short_title"
        :full-title="gamePack.title"
        :slug="gamePack.slug"
        :image="gamePack.image"
        :index="i"
        :perks="gamePack?.perks || []"
        :link="`/${currentGameSlug}/${gamePack.slug}`"
        :current-game-slug="currentGameSlug"
        :is-new="gamePack?.is_new"
        :slider-chip="false"
      />
      <PackCard
        v-if="extraPack"
        :key="extraPack"
        :title="extraPack.short_title"
        :image="extraPack.image"
        :index="2"
        :perks="extraPack?.perks || []"
        :link="`/${currentGameSlug}/${extraPack?.slug}`"
        :current-game-slug="currentGameSlug"
        :is-new="gamePack?.is_new"
        :slider-chip="false"
      />

      <div
        class="game_pack_card t-white d-flex-column space-between align-start"
        style="visibility: hidden"
        v-if="gameStore.getGameLoading"
      ></div>
    </div>
  </div>
</template>

<script setup>
import ChevLeft from "~/components/icons/ChevLeft.vue";
import ChevRight from "~/components/icons/ChevRight.vue";
import PackCard from "~/components/cards/PackCard.vue";
import { onMounted, onBeforeUnmount } from "vue";
// import { Swiper, SwiperSlide } from "swiper/vue";
// import "swiper/css";
import { ref, computed, watch } from "vue";

const breakpoints = {
  200: {
    slidesPerView: 1.25,
  },
  500: {
    slidesPerView: 2.25,
  },
  768: {
    slidesPerView: 2.5,
  },
  1024: {
    slidesPerView: 3,
  },
  1250: {
    slidesPerView: 4,
  },
  1900: {
    slidesPerView: 5.5,
  },
  2000: {
    slidesPerView: 6.5,
  },
  2400: {
    slidesPerView: 7,
  },
  2800: {
    slidesPerView: 8.5,
  },
};

// HOOKS
const { currentGameSlug } = useGameComposable();
const gameStore = useGameStore();
const router = useRouter();
const route = router.currentRoute;
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
// PROPS
const { showViewAll, extraPack, showTitle } = defineProps({
  showViewAll: {
    type: Boolean,
    default: true,
  },
  extraPack: {
    default: null,
  },
  showTitle: {
    default: true,
  },
});

// REACTIVE
const swiperRef = ref(null);
const packs_container = ref(null);
const isMounted = ref(false);

const packs = computed(() => {
  if (currentGameSlug === "counter-strike-2-boost") {
    return gameStore.getGamePacks.filter(
      (pack) => !pack.title.includes("Faceit")
    );
  }
  return gameStore.getGamePacks;
});
// METHODS
const onSwiper = (swip) => {
  swiperRef.value = swip;
};

onNuxtReady(() => {
  isMounted.value = true;
});
onMounted(() => {
  isMounted.value = true;
});
onBeforeUnmount(() => {
  isMounted.value = false;
});

watch(route, (to, from) => {
  if (to?.meta?.pageInfo?.name === "overview-game-page") {
    isMounted.value = false;
  }
});
</script>
